var l = /* @__PURE__ */ ((s) => (s.md = "md", s.medium = "medium", s.lg = "lg", s.large = "large", s))(l || {});
function u(s) {
  const r = ["tabs"];
  return s.sticky && r.push("tabs-sticky"), r.join(" ");
}
function m(s) {
  const r = ["tab", "tab-primary"];
  switch (s.size) {
    case "large":
    case "lg":
      r.push("tab-lg");
      break;
    case "medium":
    case "md":
    default:
      r.push("tab-md");
      break;
  }
  return r.join(" ");
}
function t(s) {
  return s != null && s.some((r) => !!r.order) ? s.sort((r, a) => {
    const i = e(r.order), o = e(a.order);
    return i <= o ? -1 : 1;
  }) : s;
}
function e(s) {
  return !s && s !== 0 || isNaN(s) ? 999 : s;
}
export {
  l as TabsSize,
  t as getNormalizedContent,
  m as getTabsSizeClasses,
  u as getTabsStyleClasses,
  e as normalizeOrderProp
};
